import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import useCrudStore from '@/hooks/useCrudStore'

import {
  fetchItems,
  createItem,
  updateItem,
  fetchItem,
  updateItemState,
  destroyItem,
  archiveItem,
  massEnableItem
} from '@/api/feeds'

import { IFeedsFilter } from '@/interfaces/feeds'
const defaultFilter: IFeedsFilter = {}

export const useFeedsStore = defineStore('feeds', () => {
  const {
    items,
    selected,
    closed,
    currentItems,
    total,
    filter,
    listLoading,
    itemsLoading,
    currentPage,
    SetItems,
    SetFilters,
    SetCurrentPage,
    SetSelection,
    FetchItems,
    FetchItem,
    SaveItem,
    DestroyItem,
    error,
    itemById,
    removeItem
  } = useCrudStore({
    defaultFilter,
    fetchItems,
    createItem,
    updateItem,
    fetchItem,
    destroyItem
  })

  const ChangeState = async (id: string, event: string) => {
    itemsLoading.value[id] = true
    error.value = null
    try {
      const response = await updateItemState(id, event)
      await FetchItems()
    } catch (e: any) {
      console.error(e)
      error.value = e.toString()
    } finally {
      itemsLoading.value = {}
      error.value = null
    }
  }

  const Archive = async (id: string) => {
    itemsLoading.value[id] = true
    error.value = null
    try {
      await archiveItem(id)
      removeItem(id)
    } catch (e: any) {
      console.error(e)
      error.value = e.toString()
    } finally {
      itemsLoading.value = {}
      error.value = null
    }
  }

  const MassEnable = async (id: string) => {
    itemsLoading.value[id] = true
    error.value = null
    try {
      await massEnableItem(id)
    } catch (e: any) {
      console.error(e)
      error.value = e.toString()
      throw e
    } finally {
      itemsLoading.value = {}
      error.value = null
    }
  }

  return {
    // State
    items,
    selected,
    closed,
    currentItems,
    filter,
    total,
    currentPage,
    defaultFilter,
    listLoading,

    // Actions
    SetItems,
    ChangeState,
    FetchItems,
    FetchItem,
    SaveItem,
    DestroyItem,
    Archive,
    MassEnable,
    SetFilters,
    SetCurrentPage,
    SetSelection,

    // Getters
    itemById
  }
})
